import { ParkerDTO, UpdateParkerDTO } from "src/app/base/models/models.swagger.generated";

export interface IParkerExecutionStatus {
  parkerInfo: ParkerInfo;
  status: string;
  message: string;
}

export class ParkerInfo {
  id: number;
  firstName: string;
  lastName: string;

  constructor(parker: ParkerDTO | UpdateParkerDTO) {
    this.id = parker.id;
    this.firstName = parker.firstName;
    this.lastName = parker.lastName;
  }
}
